import React from "react";

/**
 * SkyDecorations - floating clouds, birds, hot-air balloons and twinkling stars.
 * Pure CSS animations, very lightweight. Hidden in print.
 */
export const SkyDecorations = () => {
  const stars = React.useMemo(
    () =>
      Array.from({ length: 14 }).map((_, i) => ({
        id: i,
        top: `${Math.random() * 60}%`,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 2.5}s`,
        size: 4 + Math.random() * 6,
      })),
    []
  );

  return (
    <>
      <div className="world-map-bg" data-testid="world-map-bg" />
      <div className="stars" aria-hidden="true">
        {stars.map((s) => (
          <span
            key={s.id}
            className="star"
            style={{
              top: s.top,
              left: s.left,
              width: s.size,
              height: s.size,
              animationDelay: s.delay,
            }}
          />
        ))}
      </div>

      <div className="cloud cloud-1" aria-hidden="true" />
      <div className="cloud cloud-2" aria-hidden="true" />
      <div className="cloud cloud-3" aria-hidden="true" />

      <div className="bird bird-1" aria-hidden="true">
        <svg viewBox="0 0 40 20">
          <path
            d="M2 12 Q 10 2, 18 12 Q 22 8, 26 12 Q 32 2, 38 12"
            stroke="#0F2A44"
            strokeWidth="2.4"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="bird bird-2" aria-hidden="true">
        <svg viewBox="0 0 40 20">
          <path
            d="M2 12 Q 10 2, 18 12 Q 22 8, 26 12 Q 32 2, 38 12"
            stroke="#0F2A44"
            strokeWidth="2.4"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className="balloon" style={{ top: "18%", animationDelay: "-15s" }} aria-hidden="true">
        <div className="balloon-body" />
        <div className="balloon-string" />
        <div className="balloon-basket" />
      </div>
    </>
  );
};
